module.exports = __webpack_public_path__ + "static/media/check-mark-2.c720af74.svg";